import { render, staticRenderFns } from "./StickerCommentSource.vue?vue&type=template&id=4411b730&scoped=true"
import script from "./StickerCommentSource.vue?vue&type=script&lang=ts"
export * from "./StickerCommentSource.vue?vue&type=script&lang=ts"
import style0 from "./StickerCommentSource.vue?vue&type=style&index=0&id=4411b730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4411b730",
  null
  
)

export default component.exports